export const COOKIES_ENABLED = 'cookiesEnabled'
export const SCREEN_LOADING = 'screenLoading'

export const FINE_NUMBER = 'fineNumber'
export const CONFIRM_FINE_NUMBER = 'confirmFineNumber'
export const FINE_OWING = 'fineOwing'
export const PAYMENT_AMOUNT = 'paymentAmount'
export const PAYMENT_AMOUNT_FULL = 'paymentAmountFull'
export const MIN_PAYMENT_AMOUNT = 'minPaymentAmount'
export const CASE_SOT_ID = 'caseSotId'
export const RECEIPT_DETAIL = 'receiptDetail'
export const FINE_TYPE = 'fineType'
export const EMAIL_ADDRESS = 'emailAddress'
export const CONFIRM_EMAIL_ADDRESS = 'confirmEmailAddress'
export const EDIT_FINE_NUMBER = 'editFineNumber'
export const ADD_FINE = 'addFine'
export const EDIT_FINE = 'editFine'
export const DELETE_FINE = 'deleteFine'
export const CLEAR_ALL = 'clearAll'
export const CLEAR_FINE_INFO = 'clearFineInfo'
